/**
 * Reads from web storage without letting a denied storage throw. In a
 * cross-site iframe with third-party storage blocked, even touching
 * window.localStorage throws a SecurityError, so the property access sits
 * inside the try as well as the read. A missing or unreadable value is null.
 */
const readStorage = (area: 'localStorage' | 'sessionStorage', key: string): string | null => {
  try {
    return window[area].getItem(key)
  } catch {
    return null
  }
}

export const readSessionStorage = (key: string): string | null => readStorage('sessionStorage', key)

/**
 * Parses a stored JSON value, treating a missing or malformed value as absent.
 * Callers narrow the result; storage holds whatever an earlier page wrote.
 */
export const readLocalStorageJson = (key: string): unknown => {
  const raw = readStorage('localStorage', key)
  if (raw == null) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}
